/**
 * Export Configuration - Colori, font e impostazioni generali
 */

export const EXPORT_CONFIG = {
  // App info
  appName: 'Saldo Perfetto',

  // Colors
  colors: {
    primary: '#1976D2',
    primaryText: '#FFFFFF',
    headerBg: '#1976D2',
    headerText: '#FFFFFF',
    altRowBg: '#F5F5F5',
    rowBg: '#FFFFFF',
    summaryBg: '#E3F2FD',
    borderColor: '#DDDDDD',
    textPrimary: '#212121',
    textSecondary: '#757575',
    positive: '#4CAF50',
    negative: '#F44336',
  },

  // Excel settings
  excel: {
    defaultColumnWidth: 15,
    minColumnWidth: 8,
    maxColumnWidth: 50,
    titleRowHeight: 25,
    headerRowHeight: 20,
    dataRowHeight: 18,
    fontName: 'Calibri',
    fontSize: 11,
    titleFontSize: 14,
    headerFontSize: 11,
  },

  // PDF settings
  pdf: {
    marginTop: 15,
    marginBottom: 15,
    marginLeft: 15,
    marginRight: 15,
    fontSize: 9,
    headerFontSize: 10,
    titleFontSize: 14,
    subtitleFontSize: 10,
  },

  // Date/Number formatting
  formatting: {
    dateFormat: 'dd/MM/yyyy',
    currencySymbol: '€',
    decimalSeparator: ',',
    thousandsSeparator: '.',
    booleanTrue: 'Sì',
    booleanFalse: 'No',
  },
};

/**
 * Genera il nome del file con timestamp
 */
export function generateFilename(baseName: string, extension: string): string {
  const now = new Date();
  const date = now.toISOString().split('T')[0]; // YYYY-MM-DD
  const time = now.toTimeString().slice(0, 5).replace(':', ''); // HHMM
  return `${baseName}_${date}_${time}.${extension}`;
}

/**
 * Formatta una data per l'export
 */
export function formatDateForExport(date: Date | string | null | undefined): string {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(d.getTime())) return '';

  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

/**
 * Formatta un numero per l'export
 */
export function formatNumberForExport(value: number | null | undefined, decimals: number = 2): string {
  if (value === null || value === undefined) return '';
  return value.toLocaleString('it-IT', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

/**
 * Formatta una valuta per l'export
 */
export function formatCurrencyForExport(value: number | null | undefined): string {
  if (value === null || value === undefined) return '';
  return value.toLocaleString('it-IT', {
    style: 'currency',
    currency: 'EUR',
  });
}

/**
 * Formatta un booleano per l'export
 */
export function formatBooleanForExport(value: boolean | null | undefined): string {
  if (value === null || value === undefined) return '';
  return value ? EXPORT_CONFIG.formatting.booleanTrue : EXPORT_CONFIG.formatting.booleanFalse;
}

/**
 * Formatta una percentuale per l'export
 */
export function formatPercentageForExport(value: number | null | undefined): string {
  if (value === null || value === undefined) return '';
  return `${formatNumberForExport(value, 1)}%`;
}

/**
 * Genera stringa periodo (es: "gen-dic 2025")
 */
export function formatPeriod(startDate: Date | null, endDate: Date | null): string {
  if (!startDate || !endDate) return '';

  const months = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];
  const startMonth = months[startDate.getMonth()];
  const endMonth = months[endDate.getMonth()];
  const year = endDate.getFullYear();

  if (startDate.getFullYear() === endDate.getFullYear()) {
    return `${startMonth}-${endMonth} ${year}`;
  }
  return `${startMonth} ${startDate.getFullYear()}-${endMonth} ${year}`;
}
